import { useEffect, useRef } from "react";

import { Controller, useForm } from "react-hook-form";

import { ErrorText } from "../error";
import { Label } from "../label";

type Props = {
  name: string;
  label?: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  register: any;
  header?: boolean;
  setValue: any;
  required?: boolean;
  error?: any;
  leftLabel?: boolean;
  disabled?: boolean;
};

export default function TextAreaAutoHeight({
  name,
  label,
  value,
  defaultValue,
  placeholder,
  header = true,
  register,
  setValue,
  required,
  error,
  leftLabel,
  disabled,
}: Props) {
  const { control } = useForm();

  const { ref, onChange, ...rest } = register;
  const inputRef = useRef<any>(null);

  const limit = 200;

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue, { shouldValidate: true });
    }
  }, [defaultValue, setValue, name]);

  useEffect(() => {
    if (inputRef.current && inputRef.current.style) {
      setHeight();
    }
  }, [inputRef, inputRef.current?.style.height]);

  const setHeight = () => {
    inputRef.current.style.height = "";
    inputRef.current.style.height =
      Math.min(inputRef.current.scrollHeight, limit) + 2 + "px";
  };

  const handleOnChange = (e: any) => {
    if (setValue) {
      setValue(name, e.target.value);
    }

    if (inputRef) {
      setHeight();
    }
  };

  return (
    <div className={`${leftLabel ? `flex items-center` : ""}`}>
      {header && (
        <div className={`${leftLabel ? `w-3/12` : ""}`}>
          <Label name={name} label={label ?? ""} required={required} />
        </div>
      )}
      <div
        className={`${header ? `mt-2` : ""} ${
          leftLabel ? `relative w-8/12` : ""
        }`}
      >
        <Controller
          control={control}
          name={name}
          render={() => (
            <textarea
              className={`block h-10 min-h-[38px] w-full resize-none rounded-md border border-gray-300 py-2 px-3 font-input text-input shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 ${
                disabled ? "min-h-[42px] bg-stone-100" : "bg-white"
              }`}
              defaultValue={defaultValue}
              name={name}
              id={name}
              value={value}
              placeholder={placeholder}
              autoComplete="given-name"
              disabled={disabled}
              {...rest}
              ref={(e) => {
                ref(e);
                inputRef.current = e;
              }}
              onChange={(e) => {
                onChange(e);
                handleOnChange(e);
              }}
            />
          )}
        />
        {error && <ErrorText error={error} />}
      </div>
    </div>
  );
}
